import { render, staticRenderFns } from "./Psc.vue?vue&type=template&id=e4d2648c&scoped=true&"
import script from "./Psc.vue?vue&type=script&lang=js&"
export * from "./Psc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4d2648c",
  null
  
)

export default component.exports